import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { DIC } from '../../../../dic';
import { GN } from '../../../../../gn';
import * as moment from 'moment';

/**
 * Generated class for the ShowhistoryPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-showhistory',
  templateUrl: 'showhistory.html',
})
export class ShowhistoryPage {
  drn: any;
  reportData = []
  totalduration = 0;
  totaldurationStr = '';
  doneProcesses = 0;

  pauses = []
  totalpauseduration = 0;
  totalpausedurationStr = '';

  constructor(public navCtrl: NavController, public navParams: NavParams, public dic: DIC, public gn: GN) {
    this.drn = this.navParams.get('drn')
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ShowhistoryPage');
    this.loadData()
  }

  loadData() {
    this.totalduration = 0
    //debugger
    this.reportData = []
    var _that = this
    this.gn._Post('/api/gn/getrouteindoorhistory', { routeid: this.gn.crypt(this.drn.id), cid: this.gn.crypt(this.gn.user.ClientId) }, function (_data) {
      //debugger
      _that.pauses = _data.pauses
      _data = _data.data

      if (_data.length > 0) {
        for (var i = 0; i < _data.length; i++) {
          if (_data[i].processinterval != undefined) {
            var startdt = _data[i].processinterval.split(' - ')[0]
            if (startdt != '/')
              startdt = moment(startdt).format(_that.gn.user.DFormat + ' ' + _that.gn.user.TFormat)

            var enddt = _data[i].processinterval.split(' - ')[1]
            if (enddt != '/')
              enddt = moment(enddt).format(_that.gn.user.DFormat + ' ' + _that.gn.user.TFormat)

            var duration = '/';
            var dbduration = '/'
            if (_data[i].processinterval.split(' - ')[0] != '/' && _data[i].processinterval.split(' - ')[1] != '/') {
              _that.doneProcesses++;
              var sd = moment(_data[i].processinterval.split(' - ')[0])
              var ed = moment(_data[i].processinterval.split(' - ')[1])
              //_that.totalduration = _that.totalduration + parseInt((moment.duration(ed.diff(sd))).asSeconds() + '')
              _that.totalduration = _that.totalduration + parseInt(_data[i].processinterval.split(' - ')[3])
              duration = _that.sec2str(parseInt((moment.duration(ed.diff(sd))).asSeconds() + '')) + '';

              dbduration = _that.sec2str(parseInt(_data[i].processinterval.split(' - ')[3])) + ''
            }
            var pin = _data[i].processinterval.split(' - ')[2]

            _that.reportData.push({ processname: _data[i].processname, start: startdt, end: enddt, pin: pin, duration: duration, dbduration: dbduration })
          }
        }
        if (_that.totalduration != -1) {
          if (_that.doneProcesses == _data.length)
            _that.totaldurationStr = _that.sec2str(_that.totalduration) + ''
          else
            _that.totaldurationStr = _that.sec2str(_that.totalduration) + '...'
        }
      }

      if (_that.pauses.length > 0) {
        for (var i = 0; i < _that.pauses.length; i++) {

          var enddt1 = '/'
          var duration = '/'
          if (_that.pauses[i].enddt != null) {
            enddt1 = moment(_that.pauses[i].enddt).format(_that.gn.user.DFormat + ' ' + _that.gn.user.TFormat)
            var sd1 = moment(_that.pauses[i].startdt)
            var ed1 = moment(_that.pauses[i].enddt)
            _that.totalpauseduration = _that.totalpauseduration + parseInt((moment.duration(ed1.diff(sd1))).asSeconds() + '')
            duration = _that.sec2str(parseInt((moment.duration(ed1.diff(sd1))).asSeconds() + '')) + '';
          }
          _that.pauses[i].startdt = moment(_that.pauses[i].startdt).format(_that.gn.user.DFormat + ' ' + _that.gn.user.TFormat)
          _that.pauses[i].enddt = enddt1
          _that.pauses[i].duration = duration
        }
        if (_that.totalpauseduration != -1) {
          if (_that.doneProcesses == _data.length)
            _that.totalpausedurationStr = _that.sec2str(_that.totalpauseduration) + ''
          else
            _that.totalpausedurationStr = _that.sec2str(_that.totalpauseduration) + '...'
        }
      }

      //   debugger
    })
  }

  sec2str(_sec) {
    if (_sec >= 0) {

      var str = '';
      var h = Math.floor(_sec / 3600);//moment.utc(_sec * 1000).format('H');
      var m = moment.utc(_sec * 1000).format('m');
      var s = moment.utc(_sec * 1000).format('s');
      if (_sec < 60) {
        str = s + 'sec'
      }
      else {
        if (_sec < 3600) {
          str = m + 'min'
        }
        else {
          str = h + 'h ' + m + 'min'
        }
      }
      // console.log("sec2str2")  
      return str;
    }
    else {
      return -1;
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/routing/routeindoor/reportorderindoor/showhistory/showhistory.ts